import { Component, MASTER_PAGE_ID } from '@wix/thunderbolt-becky-types'
import { createCssCompNode } from '../cssCompNode'
import { FeatureRefs } from '../cssFeatures.types'
import { envRefs, themeRefs } from '@wix/thunderbolt-catharsis'
import { ThemeFontsAndColorsCssDependencies } from './themeFontsAndColors.types'
import { SelectorObj } from '../../shared.types'
import {
	getRootCssVars,
	getThemeBackColorsClasses,
	getThemeColorsClasses,
	getThemeFontsClasses,
} from './themeFontsAndColorsHelpers'

export const themeFontsAndColorsCompNode = createCssCompNode('themeFontsAndColors', 'themeFontsAndColorsCssStyle', {
	getDependencies: (component: Component, _refs: FeatureRefs<'themeFontsAndColors'>) => {
		if (component.id === MASTER_PAGE_ID) {
			return {
				shouldRenderWixAdsOnNavigation: envRefs.shouldRenderWixAdsOnNavigation,
				isWixAdsAllowed: envRefs.isWixAdsAllowed,
				isMobileView: envRefs.isMobileView,
				siteWidth: envRefs.siteWidth,
				shouldShowCoBrandingBanner: envRefs.shouldShowCoBrandingBanner,
				editorName: envRefs.editorName,
				colorData: themeRefs.siteColors,
				fontData: themeRefs.siteFonts,
				fontColorMap: themeRefs.fontColorMap,
				themeData: themeRefs.theme,
				textTheme: themeRefs.textTheme,
				experiments: envRefs.experiments,
			}
		}

		return null
	},
	toViewItem: (__, deps: ThemeFontsAndColorsCssDependencies) => {
		if (!deps) {
			return null
		}

		const rootCssVars = getRootCssVars(deps)
		const themeFontsClasses = getThemeFontsClasses(deps)
		const themeColorsClasses = getThemeColorsClasses(deps)
		const themeBackColorsClasses = getThemeBackColorsClasses(deps)

		return {
			...rootCssVars,
			...themeFontsClasses,
			...themeColorsClasses,
			...themeBackColorsClasses,
		} as SelectorObj
	},
})
